import React from "react";
import { classNames } from "utils/utils";

const TeamForm = ({ form }) => {
  if (!form) return <div className="flex  space-x-0.5 md:space-x-1"></div>;

  const formList = form
    ?.sort((a, b) => a.sort_order - b.sort_order)
    .slice(-5)
    .map((item, index) => {
      return (
        <div
          className={classNames(
            item.form == "W"
              ? "bg-customGreen"
              : item.form == "D"
              ? "bg-yellow-500"
              : "bg-red-500",

            index == 0
              ? "bg-opacity-50"
              : index == 1
              ? "bg-opacity-60"
              : index == 2
              ? "bg-opacity-80"
              : index == 3
              ? "bg-opacity-90"
              : "bg-opacity-100",
            "flex rounded-full w-4 h-4 sm:w-6 sm:h-6  text-[10px] pt-[1px] sm:pt-0 leading-4 sm:text-sm justify-center items-center text-center sm:pl-[0.075rem] text-white"
          )}
          key={item.id}
        >
          {item.form}
        </div>
      );
    });

  return (
    <div className="flex my-1 xs:my-0 items-center space-x-0.5 md:space-x-1 xs:mx-4">
      {/* xs:mx-4 */}
      {formList}
    </div>
  );
};

export default TeamForm;
